var map = {
	"./01.svg": 51,
	"./02.svg": 52,
	"./03.svg": 53,
	"./04.svg": 54,
	"./05.svg": 55,
	"./06.svg": 56,
	"./07.svg": 57,
	"./08.svg": 58,
	"./09.svg": 59,
	"./10.svg": 60,
	"./11.svg": 61,
	"./fire.svg": 17,
	"./pepper.svg": 16
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50;